export default "__VITE_ASSET__BJfhgra$__"